/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import PaymentSource from 'entities/PaymentSource';

export default class PaymentSources extends Collection {
  initialize() {
    this.model = PaymentSource;
  }

  static load() {
    return apiRequest('/payments/payment_sources', 'GET').then(
      paymentSources => PaymentSources.fromJSON(paymentSources)
    );
  }
}



// WEBPACK FOOTER //
// ./src/collections/PaymentSources.js